import { useLivestreamSessionContext } from './hooks';
import { VideoConference } from './VideoConference';
import { LiveKitRoom } from '@livekit/components-react';
import { VideoConferenceProvider } from './VideoConferenceContext';
import { getConfigOrThrow } from 'gossamer-front-end';
export const HostLivestream = () => {
  const { token, handleLeaveRoom, handleRoomConnection } = useLivestreamSessionContext();

  return (
    <div className="livestream-container">
      <LiveKitRoom
        token={token}
        serverUrl={getConfigOrThrow('livekit-ws-url')}
        onDisconnected={handleLeaveRoom}
        data-lk-theme="default"
        style={{ height: '100vh' }}
        onConnected={handleRoomConnection}
      >
        <VideoConferenceProvider>
          <VideoConference />
        </VideoConferenceProvider>
      </LiveKitRoom>
    </div>
  );
};
